const PbxxRecord = require('../pbxx_record')

module.exports = class Communication extends PbxxRecord {
  static get class_name() {
    return 'Communication'
  }
}
